/** Paid entry plan used to be stored as `free`. Checkout and webhooks still accept that alias. */
export const LEGACY_STARTER_PLAN_CODE = 'free';
export const STARTER_PLAN_CODE = 'start';

const PLAN_CODE_ALIASES: Record<string, string> = {
  free: 'start',
  starter: 'start',
  lite: 'start',
  start: 'start',
  solo: 'grow',
  professional: 'grow',
  grow: 'grow',
  growth: 'pro',
  business: 'pro',
  scale: 'pro',
  pro: 'pro',
  enterprise: 'enterprise',
};

export function canonicalizePlanCode(code: string | null | undefined): string {
  const normalized = String(code ?? '')
    .trim()
    .toLowerCase();
  return PLAN_CODE_ALIASES[normalized] ?? normalized;
}

export function planCodesEqual(left: string | null | undefined, right: string | null | undefined): boolean {
  const a = canonicalizePlanCode(left);
  const b = canonicalizePlanCode(right);
  return a.length > 0 && a === b;
}

export function planRecurringCheckoutReady(plan: {
  monthly_price_usd_cents?: number | null;
  stripe_price_id?: string | null;
  stripe_price_id_annual?: string | null;
}): { kind: 'custom' | 'ready' | 'missing'; monthly: boolean; annual: boolean } {
  if (plan.monthly_price_usd_cents == null) {
    return { kind: 'custom', monthly: false, annual: false };
  }
  const monthly = Boolean(plan.stripe_price_id?.trim());
  const annual = Boolean(plan.stripe_price_id_annual?.trim());
  return {
    kind: monthly || annual ? 'ready' : 'missing',
    monthly,
    annual,
  };
}
